import React, { useEffect, useState } from 'react';
import { getBookingSettings, saveBookingSettings } from './adminApi';
import './Admin.css';

export default function Settings() {
	const [bookingPeriod, setBookingPeriod] = useState('once_per_three_weeks');
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		getBookingSettings()
			.then((data) => {
				setBookingPeriod(data.bookingPeriod || 'once_per_three_weeks');
				setOptions(data.options || []);
			})
			.catch((e) => {
				console.error(e);
				alert(e.message || 'Не удалось загрузить настройки');
			})
			.finally(() => setLoading(false));
	}, []);

	const handleSave = async () => {
		setSaving(true);
		try {
			const data = await saveBookingSettings(bookingPeriod);
			setBookingPeriod(data.bookingPeriod);
			setOptions(data.options || options);
			alert('Настройки сохранены');
		} catch (e) {
			alert(e.message || 'Ошибка сохранения');
		} finally {
			setSaving(false);
		}
	};

	if (loading) return <div>Загрузка настроек...</div>;

	return (
		<div style={{ maxWidth: 520 }}>
			<h3 style={{ marginTop: 0 }}>Настройки</h3>

			<label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
				Период ограничения записи
			</label>
			<p style={{ marginTop: 0, marginBottom: 12, color: '#555', fontSize: 14 }}>
				Минимальный промежуток между записями одного пользователя.
				Число будущих записей не ограничено — только интервал между ними.
			</p>

			<select
				value={bookingPeriod}
				onChange={(e) => setBookingPeriod(e.target.value)}
				style={{
					width: '100%',
					padding: '8px 10px',
					borderRadius: 6,
					border: '1px solid #ccc',
					marginBottom: 16,
				}}
			>
				{options.map((opt) => (
					<option key={opt.value} value={opt.value}>
						{opt.label}
					</option>
				))}
			</select>

			<button
				type="button"
				className="btn_admin"
				onClick={handleSave}
				disabled={saving}
			>
				{saving ? 'Сохранение...' : 'Сохранить'}
			</button>
		</div>
	);
}
